import React from 'react';

import {Button} from '@kit';

import type {CharacterAction} from '../../model/collect-effects';
import {formatDice, parseDice} from '../../model/dice';
import {useRoll} from '../dice-roller';
import {useFeatureAction} from './use-feature-action';

/**
 * «Применить» тратит одно использование: Дикий облик, Порыв к действию.
 * Если применение бросает кость ресурса, кость видна на кнопке и бросается тем же нажатием.
 */
export const UseButton: React.FC<{action: CharacterAction}> = ({action}) => {
	const {hasUses, canUse, rollDice, spend} = useFeatureAction(action);
	const roll = useRoll();
	if (!hasUses) return null;
	const formula = rollDice ? parseDice(rollDice) : undefined;

	const use = () => {
		spend();
		if (formula) roll({title: action.title, formula});
	};

	return (
		<Button size="small" disabled={!canUse} onClick={use}>
			{canUse ? 'Применить' : 'Применено'}
			{canUse && formula && ` (${formatDice(formula)})`}
		</Button>
	);
};
